import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import moment from 'moment';

import {
  Form,
  FormItem,
  Input,
  InputNumber,
  Slider,
  DatePicker,
  Radio,
} from 'formik-antd';
import { Formik } from 'formik';
import { dateFormat, timeOptions } from 'utils/dates';

import schema from './schema';
import './style.css';

const initialValues = {
  dateRange: [
    moment().clone().add(1, 'day'),
    moment().clone().add(1, 'day').add(2, 'hours'),
  ],
  shiftTime: 0,
  rate: 10,
  notes: '',
};

const RequestBookingModal = ({ visible, onCancel, onSubmit }) => {
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={schema}
    >
      {({ isSubmitting, submitForm }) => {
        return (
          <Modal
            className="request-booking-modal"
            title="Request Booking"
            visible={visible}
            onOk={() => {
              submitForm();
            }}
            confirmLoading={isSubmitting}
            onCancel={onCancel}
          >
            <Form layout="vertical" className="wrapper">
              <FormItem label="Dates" name="dateRange">
                <DatePicker.RangePicker
                  name="dateRange"
                  format={dateFormat}
                  disabledDate={(current) =>
                    current && current < moment().endOf('day')
                  }
                />
              </FormItem>

              <FormItem label="Shift Time" name="shiftTime">
                <Radio.Group name="shiftTime" defaultValue={0}>
                  {timeOptions.map((item, idx) => (
                    <Radio.Button key={idx} value={idx}>
                      {item.startTime}-{item.endTime}
                    </Radio.Button>
                  ))}
                </Radio.Group>
              </FormItem>

              <FormItem label="Hour rate" name="rate" className="hour-rate">
                <Slider
                  name="rate"
                  min={10}
                  max={100}
                  step={1}
                  tipFormatter={(v) => `£${v}`}
                  tooltipPlacement="bottom"
                />
                <InputNumber name="rate" min={10} max={100} />
              </FormItem>

              <FormItem label="Notes" name="notes">
                <Input.TextArea
                  name="notes"
                  placeholder="Extra comments for the worker"
                  autoSize={{ minRows: 6 }}
                />
              </FormItem>
            </Form>
          </Modal>
        );
      }}
    </Formik>
  );
};

RequestBookingModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
export default RequestBookingModal;
